module.exports = __webpack_public_path__ + "static/img/bg-place.54518ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bg-place.png
// module id = 121
// module chunks = 1